import React, { useEffect, useState, useCallback, useRef } from "react";
import "./Navbar.css";
import logo from "../../Assets/Images/Navbar/white_docity.png";
import { Button, Modal, Form } from "react-bootstrap";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {
    LayoutDashboard,
    ClipboardCheck,
    UserCog,
    ChevronDown,
    LogOut,
} from "lucide-react";
import service from "../../Services/AuthService";
import PropertiesService from "../../Services/PropertiesService";
import userProfile from "../../Assets/Images/Navbar/profile-user.png";
import { validateFileSize, normalizeUploadResponse } from "../../utils/uploadUtils";


const navItems = [
    { label: "Dashboard", key: "Dashboard", path: "dashboard", icon: LayoutDashboard },
    { label: "Properties Assigned", key: "Req-Property", path: "reqProperty", icon: ClipboardCheck },
    { label: "Edit Profile", key: "profileEdit", path: "profileEdit", icon: UserCog },
];

const Navbar = ({ userStatus22 }) => {
    const [ColorChange, setColorChange] = useState("Edit Account");
    const [, setEditModelShow] = useState(false);
    const [, setSubmitError] = useState([]);
    const fileInputRef = useRef(null);
    const [userImage, setUserImage] = useState("");

    const [, setIsLoading] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [, setUploadFileLoader] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [, setUploadedFile] = useState(null);
    const [, setSelectedUser] = useState({});
    const [, setHasError] = useState(false);
    const [, setCivilEngineerDetails] = useState([]);

    const navigate = useNavigate();
    const [userStatus, setUserStatus] = useState(userStatus22);
    const [, setAdmissionStatus] = useState('');
    const location = useLocation();
    const [dropDown, setDropDown] = useState(false);
    const [mobileNav, setMobileNav] = useState(false);
    const [userDetails, setUserDetails] = useState({});
    const [openEditModel, setopenEditModel] = useState(false);
    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [error, setError] = useState({});
    const [, setSubAdminDetails] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [, setTabMode] = useState("Edit Account");
    const [userData, setUserData] = useState({
        name: "",
        phone: "",
        email: "",
    });

    useEffect(() => {
        const admin = JSON.parse(localStorage.getItem("adminDetails"));
        setUserDetails(admin ?? {});
        if (admin?.userType !== "super admin") {
            getSubAdminDetails(admin?.subAdmin_id);
        }
    }, []);

    useEffect(() => {
        setMobileNav(false);
    }, [location.pathname]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setMobileNav(false);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getSubAdminDetails = async (id) => {
        if (!id) return;
        const response = await service.getSingleSubAdmin({ userId: id });
        if (response.message === "Success") {
            setSubAdminDetails(response.data);
        }
    };

    const handleNav = async (key, path) => {
        const response = await service.getUserInformation({ userId: userDetails.civilEng_id });
        if (response?.data?.status === 'Approved' && response?.data?.Personal_Details.length > 0) {
            navigate(path);
        }
        setMobileNav(false);
    };


    const editUser = async () => {
        const phonePattern = /^\d{10}$/;
        if (!userData.name) {
            setError({ name: "Enter Name" });
            setTimeout(() => {
                setError([]);
            }, 2000);
        } else if (!userData.phone) {
            setError({ phone: "Enter phone" });
            setTimeout(() => {
                setError([]);
            }, 2000);
        } else if (!phonePattern.test(userData.phone)) {
            setError({ phoneNumber: "Enter a valid 10-digit phone number." });
            setTimeout(() => {
                setError([]);
            }, 2000);
        } else {
            let obj = {
                id: userDetails.admin_id,
                name: userData.name,
                phoneNumber: userData.phone,
            };
            const response = await service.editAdmin(obj);
            if (response.message === "Success") {
                toast.success("Admin Details Updated Successfully");
                localStorage.setItem("adminDetails", JSON.stringify(response.data));
                setTimeout(() => {
                    setopenEditModel(false);
                    setUserDetails(response.data);
                }, 2000);
            } else {
                toast.error("Failed to Updated User");
            }
        }
    };
    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        if (!validatePassword(value)) {
            setError({
                password:
                    "Password must be at least 8 characters, include one number and one special character.",
            });
        } else {
            setError("");
        }
    };
    const handleNewPasswordChange = (e) => {
        const value = e.target.value;
        setNewPassword(value);
        if (!validatePassword(value)) {
            setError({
                newPassword:
                    "Password must be at least 8 characters, include one number and one special character.",
            });
        } else {
            setError("");
        }
    };
    const changePassword = async () => {
        if (!password) {
            setError({ password: "Enter password" });
            setTimeout(() => {
                setError([]);
            }, 2000);
        } else if (!newPassword) {
            setError({ newPassword: "Enter newPassword" });
            setTimeout(() => {
                setError([]);
            }, 2000);
        } else if (password === newPassword) {
            setError({ match: "Password And New Password Should Be Different" });
            setTimeout(() => {
                setError([]);
            }, 2000);
        } else {
            if (Error.length === 0) {
                let obj = {
                    email: userDetails.email,
                    oldPassword: password,
                    newPassword: newPassword,
                };
                const response = await service.UpdatePassword(obj);
                if (response.message === "Success") {
                    // toast.success("Admin Details Updated Successfully");
                    localStorage.setItem("adminDetails", JSON.stringify(response.data));
                    setTimeout(() => {
                        setopenEditModel(false);
                        setUserDetails(response.data);
                    }, 2000);
                } else {
                    toast.error(response);
                }
            }
        }
    };
    const validatePassword = (value) =>
        /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/.test(value);
    const handleEditClose = () => {
        setopenEditModel(false);
    };
    // eslint-disable-next-line no-unused-vars
    const _logoutFunction = () => {
        navigate("/");
        localStorage.clear();
    };
    const isActive = (route) => location.pathname.includes(route) ? "active" : "";
    /* Values are unchanged (the API keys off them); only the presentation moves
       onto the shared status tokens. */
    const dropdownList = [
        { label: 'Active', value: 'Active', tone: 'success' },
        { label: 'Temporarily Away', value: 'Temporarily away', tone: 'warning' },
        { label: 'On Leave', value: 'On Leave', tone: 'info' },
    ];
    // eslint-disable-next-line no-unused-vars
    const _onLoad = () => {
        setIsLoading(false);
        setHasError(false);
    };

    // eslint-disable-next-line no-unused-vars
    const _onError = () => {
        setIsLoading(false);
        setHasError(true);
    };

    // eslint-disable-next-line no-unused-vars
    const _handleRemove = (index) => {
        const updatedFiles = [...uploadedFiles];
        updatedFiles.splice(index, 1);
        setUploadedFiles(updatedFiles);
    };

    // eslint-disable-next-line no-unused-vars
    const _handleEdit = (user) => {
        setSelectedUser(user);
        setUserData({
            name: user.name,
            email: user.email,
            phone: user.phoneNumber,
            FamilyHistory: [
                {
                    reference1: {
                        address: user.FamilyHistory?.[0]?.reference1?.address || '',
                        name: user.FamilyHistory?.[0]?.reference1?.name || '',
                        phone: user.FamilyHistory?.[0]?.reference1?.phone || '',
                        relation: user.FamilyHistory?.[0]?.reference1?.relation || '',
                    },
                    reference2: {
                        address: user.FamilyHistory?.[0]?.reference2?.address || '',
                        name: user.FamilyHistory?.[0]?.reference2?.name || '',
                        phone: user.FamilyHistory?.[0]?.reference2?.phone || '',
                        relation: user.FamilyHistory?.[0]?.reference2?.relation || '',
                    },
                },
            ],
            Office_Address: [
                {
                    Designation: user.Office_Address?.[0]?.Designation || "",
                    businessType: user.Office_Address?.[0]?.businessType || "",
                    bussinessAddress: user.Office_Address?.[0]?.bussinessAddress || "",
                    bussinessTitle: user.Office_Address?.[0]?.bussinessTitle || "",
                    occupation: user.Office_Address?.[0]?.occupation || "",
                    organisationName: user.Office_Address?.[0]?.organisationName || "",
                    years: user.Office_Address?.[0]?.years || "",
                }
            ],
            Personal_Details: [
                {
                    name: user.Personal_Details?.[0]?.name || "",
                    age: user.Personal_Details?.[0]?.age || "",
                    gender: user.Personal_Details?.[0]?.gender || "",
                    passedOutYear: user.Personal_Details?.[0]?.passedOutYear || "",
                    universityName: user.Personal_Details?.[0]?.universityName || "",
                }
            ],
            Personal_Address: [
                {
                    address: user.Personal_Address.length > 0 ? user.Personal_Address[0].address : "",
                    pincode: user.Personal_Address.length > 0 ? user.Personal_Address[0].pincode : "",

                }
            ],
            PreferredRegions: user.PreferredRegions,
            docs: user.docs
        });
        setUploadedFiles(user.docs)
        setEditModelShow(true);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (!value) {
            setError({ error: 'enter value', name: name })
            setSubmitError({ error: 'enter value', name: name })
        } else {
            setError([])
        }
        if (name.includes('reference')) {
            const referenceIndex = name.includes('reference1') ? 0 : 1;
            let fieldName = name.replace(`reference${referenceIndex + 1}`, '');
            setUserData((prevState) => {
                const updatedFamilyHistory = [...prevState.FamilyHistory];
                updatedFamilyHistory[0] = {
                    ...updatedFamilyHistory[0],
                    [`reference${referenceIndex + 1}`]: {
                        ...updatedFamilyHistory[0][`reference${referenceIndex + 1}`],
                        [fieldName]: value,
                    },
                };
                return { ...prevState, FamilyHistory: updatedFamilyHistory };
            });
        }
        else if (name.includes('Office_Address')) {
            const fieldName = name.replace('Office_Address', '');
            setUserData((prevState) => {
                const updatedOffice_Address = [...prevState.Office_Address];
                updatedOffice_Address[0] = { ...updatedOffice_Address[0], [fieldName]: value };
                return { ...prevState, Office_Address: updatedOffice_Address };
            });
        }
        else if (name.includes('Personal_Details')) {
            const fieldName = name.replace('Personal_Details', '');
            setUserData((prevState) => {
                const updatedPersonal_Details = [...prevState.Personal_Details];
                updatedPersonal_Details[0] = { ...updatedPersonal_Details[0], [fieldName]: value };
                return { ...prevState, Personal_Details: updatedPersonal_Details };
            });
        }
        else if (name.includes('Personal_Address')) {
            const fieldName = name.replace('Personal_Address', '');
            setUserData((prevState) => {
                const updatedPersonal_Address = [...prevState.Personal_Address];
                updatedPersonal_Address[0] = { ...updatedPersonal_Address[0], [fieldName]: value };
                return { ...prevState, Personal_Address: updatedPersonal_Address };
            });
        }
        else {
            setUserData({
                ...userData,
                [name]: value,
            });
        }
        ;
    };
    // eslint-disable-next-line no-unused-vars -- used in onClick at line ~520
    const handleProfileImageClick = () => {
        fileInputRef.current.click();
    };
    const handleFileUpload = async (e, name) => {
        const file = e.target.files[0];
        if (!file) return;

        const sizeError = validateFileSize(file);
        if (sizeError) {
          toast.error(sizeError);
          return;
        }

        const formData = new FormData();
        formData.append("image", file);

        //   setLoading(name);

        try {
            const response = await PropertiesService.UploadFiles(formData);
            console.log(response, 'responseewwwww')
            const fileUrl = normalizeUploadResponse(response);

            if (fileUrl) {
                if (name === "User Image") {
                    setUserImage(fileUrl);
                } else {
                    setUploadedFile((prev) => [
                        ...(prev || []),
                        { docName: name, url: fileUrl },
                    ]);
                }
            } else {
                toast.error("Upload failed. Please try again.");
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            toast.error("File upload failed");
        } finally {
            // setLoading("");
        }
    };

    const handleProfileImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            setIsLoading(true);

            const fakeEvent = { target: { files: [file] } };
            await handleFileUpload(fakeEvent, "User Image");

            const userDetails = JSON.parse(localStorage.getItem("userDetails"));
            const obj = {
                userId: userDetails.civilEng_id,
                name: userDetails.name,
                phoneNumber: userDetails.phoneNumber,
                image: userImage,
                docs: userDetails.docs,

                WillingnessToWork: userDetails.WillingnessToWork,
                submit_to_DoCity_with_sincerity_and_honesty: userDetails.submit_to_DoCity_with_sincerity_and_honesty,

                Personal_Details: userDetails.Personal_Details,

                Personal_Address: userDetails.Personal_Address,

                Office_Address: userDetails.Office_Address,

                videoTutorial: userDetails.videoTutorial,

                PreferredRegions: userDetails.PreferredRegions,

                FamilyHistory: userDetails.FamilyHistory,

                SRO_TYPE: "",
            };

            const response = await PropertiesService.editCivilEngineer(obj);
            console.log(response, 'response')
            if (response?.data?.message === "Success") {
                toast.success("Profile image updated successfully");

                const updatedUser = {
                    ...userDetails,
                    image: response.data.data.image,
                };

                localStorage.setItem("userDetails", JSON.stringify(updatedUser));
                setUserDetails(updatedUser);
            } else {
                toast.error("Failed to update profile");
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        } finally {
            setIsLoading(false);
        }
    };



    useEffect(() => {
        const data = JSON.parse(localStorage.getItem('userDetails'));
        const admissionStatus = localStorage.getItem('Admission')
        setAdmissionStatus(admissionStatus)
        getCivilEngineer(data?.civilEng_id)
        if (data) {
            setUserDetails(data);
            setUserStatus(data?.activeStatus);
        }
        if (userStatus22) {
            setUserStatus(userStatus22)
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only; getCivilEngineer defined below
    }, []);
    const getCivilEngineer = useCallback(async (id) => {
        let obj = {
            userId: id
        }
        const response = await PropertiesService.getCivilEngineer(obj)
        setCivilEngineerDetails(response?.data?.data)
        if (response?.data?.data) {
            setUserDetails(response?.data?.data);
            setUserStatus(response?.data?.data.activeStatus);
        }
        console.log(response, 'response')
    }, [])
    // eslint-disable-next-line react-hooks/exhaustive-deps -- getCivilEngineer and userStatus22 intentionally excluded
    useEffect(() => {
        getCivilEngineer();
        const handleFocus = () => getCivilEngineer();
        window.addEventListener('focus', handleFocus);
        return () => window.removeEventListener('focus', handleFocus);
    }, [getCivilEngineer]);

    // eslint-disable-next-line no-unused-vars
    const _handleRemoveRegion = (index) => {
        const updatedRegions = [...userData.PreferredRegions];
        updatedRegions.splice(index, 1);
        setUserData({ ...userData, PreferredRegions: updatedRegions });
    }
    const handleStatusChange = async (event) => {
        const newStatus = event.target.value;
        setUserStatus(newStatus);

        const updatedUser = { ...userDetails, status: newStatus };
        let obj = {
            status: updatedUser.status,
            userId: userDetails.civilEng_id
        }
        const response = await service.updateActiveStatus(obj)
        if (response.message === 'Success') {
            // setTimeout(() => {
            //     toast.success('Status Changed Successfully');
            // }, 200);
            let objw = {
                userId: userDetails.civilEng_id
            }
            const getUserInformation = await service.getUserInformation(objw)
            if (getUserInformation.message === 'Success') {
                localStorage.setItem('userDetails', JSON.stringify(getUserInformation.data))
            }
        } else {
            toast.error(response)
        }
    };
    // eslint-disable-next-line no-unused-vars
    const _handleDatas = (x) => {
        const item = localStorage.getItem('Admission')
        if (item === 'No') {
            navigate('profile-edit')
        } else {
            navigate(x)
            getCivilEngineer(userDetails.civilEng_id)
        }
    }
    const canSetStatus =
        userDetails.status !== 'Pending' && userDetails.panNumber !== '';

    return (
        <>
            <div className="navbar-root">
                <a className="ds-skip-link" href="#main-content">
                    Skip to main content
                </a>

                <header className="navbar-header">
                    <div className="navbar-leftContent">
                        <button
                            className={`navbar-hamburger${mobileNav ? " is-open" : ""}`}
                            type="button"
                            onClick={() => setMobileNav((prev) => !prev)}
                            aria-label={mobileNav ? "Close navigation" : "Open navigation"}
                            aria-expanded={mobileNav}
                            aria-controls="primary-navigation"
                        >
                            <span />
                            <span />
                            <span />
                        </button>
                        <div className="navbar-brand">
                            <img src={logo} alt="DoCity" className="navbar-logo" />
                            <span className="navbar-role">
                                <span className="navbar-role__dot" />
                                Civil Engineer
                            </span>
                        </div>
                    </div>

                    <div className="navbar-header__right">
                        {canSetStatus && (
                            userStatus22 !== '' ? (
                                <span className="navbar-status-flag">{userStatus22}</span>
                            ) : (
                                <label className="navbar-status">
                                    <span className="ds-sr-only">Availability status</span>
                                    <span
                                        className={`navbar-status__dot navbar-status__dot--${
                                            dropdownList.find((item) => item.value === userStatus)?.tone || 'neutral'
                                        }`}
                                        aria-hidden="true"
                                    />
                                    <select
                                        className="status-dropdown"
                                        value={userStatus}
                                        onChange={handleStatusChange}
                                    >
                                        {dropdownList.map((status) => (
                                            <option key={status.value} value={status.value}>
                                                {status.label}
                                            </option>
                                        ))}
                                    </select>
                                    <ChevronDown className="navbar-status__chevron" aria-hidden="true" />
                                </label>
                            )
                        )}

                        <div
                            className="navbar-user"
                            role="button"
                            tabIndex={0}
                            aria-haspopup="menu"
                            aria-expanded={dropDown}
                            onClick={() => setDropDown((d) => !d)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    setDropDown((d) => !d);
                                }
                                if (e.key === "Escape") setDropDown(false);
                            }}
                        >
                            <img
                                src={userDetails.image || userProfile}
                                alt=""
                                className="navbar-user-avatar"
                            />
                            <span className="navbar-user__text">
                                <span className="navbar-user-name">{userDetails.name}</span>
                                <span className="navbar-user__sub">{userDetails.email}</span>
                            </span>
                            <span className="navbar-user__chevron" aria-hidden="true">
                                <ChevronDown />
                            </span>

                            {dropDown && (
                                <div
                                    className="navbar-dropdown"
                                    role="menu"
                                    onMouseLeave={() => setDropDown(false)}
                                >
                                    <div className="navbar-dropdown__header">
                                        <span className="navbar-dropdown__name">{userDetails.name}</span>
                                        <span className="navbar-dropdown__email">{userDetails.email}</span>
                                    </div>
                                    <button
                                        className="dropdown-item dropdown-item--danger"
                                        role="menuitem"
                                        onClick={() => {
                                            localStorage.clear();
                                            navigate("/");
                                        }}
                                    >
                                        <LogOut aria-hidden="true" />
                                        <span>Log out</span>
                                    </button>

                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        onChange={handleProfileImageChange}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </header>

                {mobileNav && (
                    <button
                        className="navbar-sidebar-overlay is-visible"
                        aria-label="Close navigation"
                        onClick={() => setMobileNav(false)}
                    />
                )}

                <nav
                    id="primary-navigation"
                    className={`navbar-sidebar${mobileNav ? " open" : ""}`}
                    aria-label="Primary"
                >
                    {navItems.map(({ label, key, path, icon: Icon }) => (
                        <button
                            className={`navbar-link ${isActive(path)}`}
                            key={key}
                            onClick={() => handleNav(key, path)}
                            aria-current={isActive(path) ? "page" : undefined}
                        >
                            <span className="navbar-link__icon" aria-hidden="true">
                                <Icon />
                            </span>
                            <span className="navbar-link__label">{label}</span>
                        </button>
                    ))}
                </nav>

                <main className="navbar-main" id="main-content">
                    <Outlet />
                </main>
                <ToastContainer
                    autoClose={2000}
                    position="top-right"
                    newestOnTop
                    closeOnClick
                    theme="light"
                />
            </div>
            <Modal show={openEditModel} onHide={handleEditClose} centered>
                <Modal.Header closeButton>
                    <div className="ds-stack" style={{ gap: "var(--ds-space-4)", width: "100%" }}>
                        <div>
                            <h2 className="ds-modal__title">Account settings</h2>
                            <p className="ds-modal__subtitle">
                                Update your profile details or change your password
                            </p>
                        </div>
                        <div className="ds-tabs" role="tablist" aria-label="Account settings sections">
                            <button
                                type="button"
                                role="tab"
                                className="ds-tab"
                                aria-selected={ColorChange === "Edit Account"}
                                onClick={() => setColorChange("Edit Account")}
                            >
                                Profile
                            </button>
                            <button
                                type="button"
                                role="tab"
                                className="ds-tab"
                                aria-selected={ColorChange === "Edit Password"}
                                onClick={() => setColorChange("Edit Password")}
                            >
                                Password
                            </button>
                        </div>
                    </div>
                </Modal.Header>
                {ColorChange === "Edit Account" ? (
                    <>
                        <Modal.Body className="tableInModel">
                            <div className="ds-stack" style={{ gap: "var(--ds-space-5)" }}>
                                <Form.Group controlId="formName" className="ds-field">
                                    <Form.Label>
                                        Name <span className="ds-label__required">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter name"
                                        name="name"
                                        value={userData.name}
                                        onChange={handleChange}
                                        isInvalid={!!error.name}
                                    />
                                    {error.name && <p className="ds-field__error">{error.name}</p>}
                                </Form.Group>
                                <Form.Group controlId="formPhone" className="ds-field">
                                    <Form.Label>
                                        Phone <span className="ds-label__required">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="10-digit mobile number"
                                        name="phone"
                                        value={userData.phone}
                                        onChange={handleChange}
                                        isInvalid={!!(error.phone || error.phoneNumber)}
                                    />
                                    {error.phone && <p className="ds-field__error">{error.phone}</p>}
                                    {error.phoneNumber && (
                                        <p className="ds-field__error">{error.phoneNumber}</p>
                                    )}
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleEditClose}>
                                Cancel
                            </Button>
                            <Button variant="primary" onClick={editUser}>
                                Save changes
                            </Button>
                        </Modal.Footer>
                    </>
                ) : (
                    <>
                        <Modal.Body className="tableInModel">
                            <div className="ds-stack" style={{ gap: "var(--ds-space-5)" }}>
                                <Form.Group controlId="formCurrentPassword" className="ds-field">
                                    <Form.Label>
                                        Current password <span className="ds-label__required">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter current password"
                                        name="password"
                                        value={userData.password}
                                        onChange={handlePasswordChange}
                                        isInvalid={!!error.password}
                                    />
                                    {error.password && <p className="ds-field__error">{error.password}</p>}
                                </Form.Group>
                                <Form.Group controlId="formNewPassword" className="ds-field">
                                    <Form.Label>
                                        New password <span className="ds-label__required">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter new password"
                                        name="newPassword"
                                        value={userData.newPassword}
                                        onChange={handleNewPasswordChange}
                                        isInvalid={!!(error.newPassword || error.match)}
                                    />
                                    {error.newPassword ? (
                                        <p className="ds-field__error">{error.newPassword}</p>
                                    ) : (
                                        <p className="ds-field__hint">
                                            At least 8 characters, including one number and one special
                                            character.
                                        </p>
                                    )}
                                    {error.match && <p className="ds-field__error">{error.match}</p>}
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleEditClose}>
                                Cancel
                            </Button>
                            <Button variant="primary" onClick={changePassword}>
                                Update password
                            </Button>
                        </Modal.Footer>
                    </>
                )}
            </Modal>
        </>
    );
};

export default Navbar;
